/* unplugin-vue-components disabled */import { render } from "./asktug.vue?vue&type=template&id=41ac4fa5&scoped=true"
import script from "./asktug.vue?vue&type=script&lang=js"
export * from "./asktug.vue?vue&type=script&lang=js"

import "./asktug.vue?vue&type=style&index=0&id=41ac4fa5&lang=sass&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ac4fa5"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
